import { nanoid } from '@reduxjs/toolkit';

const id = nanoid();

export default function Layout({ color = '#000000', ...props }: Record<string, unknown> & { color?: string }) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>layout</title>
      <defs>
        <path
          d="M3,20 C1.34314575,20 0,18.6568542 0,17 L0,3 C0,1.34314575 1.34314575,0 3,0 L17,0 C18.6568542,0 20,1.34314575 20,3 L20,17 C20,18.6568542 18.6568542,20 17,20 L3,20 Z M6,8 L2,8 L2,17 C2,17.5522847 2.44771525,18 3,18 L6,18 L6,8 Z M18,8 L8,8 L8,18 L17,18 C17.5522847,18 18,17.5522847 18,17 L18,8 Z M17,2 L3,2 C2.44771525,2 2,2.44771525 2,3 L2,6 L18,6 L18,3 C18,2.44771525 17.5522847,2 17,2 Z"
          id={id}
        />
      </defs>
      <g id="🕹-Icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Feather" transform="translate(-769, -195)">
          <g id="layout" transform="translate(771, 197)">
            <mask id={`mask-${id}`} fill="white">
              <use xlinkHref={`#${id}`} />
            </mask>
            <use id="Combined-Shape" fill={color} fillRule="nonzero" xlinkHref={`#${id}`} />
            <g id="COLOR/-black" mask={`url(#mask-${id})`} fill={color}>
              <g transform="translate(-2, -2)" id="Rectangle">
                <rect x={0} y={0} width={24} height={24} />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
